/**
 * Get the API URL for the current environment.
 *
 * This used to return window.location.origin on any letthebeatbuild.me host,
 * which was correct on Emergent where a single deployment served both the
 * frontend and the API. They are separate now (frontend on Cloudflare Pages,
 * backend on Fly), so same-origin would send every API call to the static host
 * and 404. An explicitly configured backend URL always wins; origin is only a
 * fallback for a genuinely same-origin deployment.
 */
export const getApiUrl = () => {
  if (process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL;
  }
  return typeof window !== 'undefined' ? window.location.origin : '';
};

export const API_URL = getApiUrl();
